export default __webpack_public_path__ + "static/media/Animations_Clock1.ee6effbb.svg";